import { Route, Switch } from 'react-router-dom'
import NotFoundPage from '../404/NotFoundPage'
import { ROUTER_PATH } from './metaData'
import ProfileScreen from '../profile'
import ProductsManagement from '../products'
import OrderManagement from '../order'
import ReportManagement from '../report'
import WarehouseManagement from '../warehouse-management'
import TagManagement from '../tag-management'
import ListProductsManagement from '../products/ListProducts'
import FundManagement from '../fund-management'
import PriceManagement from '../price-management'
import DefaultSellerScreen from '../default/DefaultSellerScreen'
import IntroPage from '../Intro/Intro'
import TransactionHistory from '../transaction-history'
import DraftOrderManagement from '../draft-order'
import PaymentScreen from '../payment'
import WebhookManagement from '../webhook-management'
const SellerRouters = (props: any) => {
   return (
      <Switch>
         <Route exact path={`/`} component={DefaultSellerScreen} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.IntroPage}`} component={IntroPage} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TagManagementScreen}`} component={TagManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.PriceManagement}`} component={PriceManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ProfileScreen}`} component={ProfileScreen} />

         <Route exact path={`${props.match.url}${ROUTER_PATH.ProductsManagement}`} component={ProductsManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.OrderManagement}`} component={OrderManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.OrderDraftManagement}`} component={DraftOrderManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.ReportManagement}`} component={ReportManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.WarehouseManagement}`} component={WarehouseManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.FundManagement}`} component={FundManagement} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.TransactionHistory}`} component={TransactionHistory} />
         <Route exact path={`${props.match.url}${ROUTER_PATH.PaymentScreen}`} component={PaymentScreen} />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.WebhookManagementScreen}`}
            component={WebhookManagement}
         />
         <Route
            exact
            path={`${props.match.url}${ROUTER_PATH.ListProductsManagement}`}
            component={ListProductsManagement}
         />

         <Route path="*" component={NotFoundPage} />
      </Switch>
   )
}

export default SellerRouters
